function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function changeLinks() {
  console.log('generate new wholesale links');
  var elements = window.document.getElementsByTagName('a');
  console.log(elements.length);
    for (var i=0; i<elements.length; i++) {
        text = elements[i].getAttribute("href"); 
        {
          if ( text == null )
            continue;
          
          let indexS = text.search("view=wholesale");
          if ( indexS > 0 ) 
            console.log('pass')
          else {
            if ( text.indexOf("?") > -1  ) { 
              nhref = text + "&view=wholesale"; 
              }
            else
              nhref = text + "?view=wholesale";
            elements[i].setAttribute("href", nhref);
          }
        }
    } 
}